const getSteps = (navigatePath) => {
    let initialPath = String(window.location.search).split("?pageName=")
    if (initialPath && initialPath.length === 1) initialPath = String(window.location.search).split("&pageName=")
    const finalPath = String(initialPath[1]).split("%252F").filter(data => (data !== undefined && data) ? true : false)
    const finalPath1 = navigatePath ? String(navigatePath).split('/') : ''
    let finalPathResult = ''
    if (finalPath1 && finalPath1.length === 3) finalPathResult = finalPath1[1] + '/' + finalPath1[2]
    else if (finalPath1) finalPathResult = finalPath1[0] + '/' + finalPath1[1]
    const getSwitchPath = finalPathResult ? finalPathResult : (finalPath && finalPath.length > 0) ? (finalPath[0] + '/' + finalPath[1]) : ''
    return getSwitchPath
}
const isMarketplaceFromProspect = () => {
    let initialPath = String(window.location.pathname).split("/")
    let initialPathLength = initialPath.length
    if (!initialPath[initialPathLength - 1]) {
        initialPath.pop()
        initialPathLength -= 1
    }
    if (String(initialPath[initialPathLength - 1]).toLowerCase().includes('marketplace')) return true
    return false
}

export const getFlow = ({ showProtection = false, haveJO = false, globalData, pathForSteps = undefined, hasAccount = false, selectAccountFlow = '', fromMarketplace = false, navigatePath = '',
    isByorSelected = false,isByor=false,isSingleAddress=false }) => {
    const getSwitchPath = getSteps(navigatePath)
    if (isMarketplaceFromProspect()) return 'labelForMarketplaceFlow'
    if (fromMarketplace) return 'labelForMarketplaceFlow'
    if (selectAccountFlow === 'addaline') return 'labelForNSEFlowWithAccount'
    if (selectAccountFlow === 'byod') return 'labelForBYODFlowWithAccount'
    switch (getSwitchPath) {
        case 'fwa/qualification-selection': 
            if(isByor) {
                if(isSingleAddress) return 'labelForFWALoggedInOneRouter';
                else return 'labelForFWALoggedInBYOR'
            }
            return "labelForFWALoggedIn"
        case "fwa/plans": {
            if(isSingleAddress && isByor) return 'labelForFWALoggedInOneRouter';
            if (isByorSelected) {
                return 'titleForLTEMarketplaceByor';
            }
            return 'titleForLTEMarketplace';
        }
        case "5g/plans": {
            if(isSingleAddress && isByor) return 'labelForFWALoggedInOneRouter';
            if (isByorSelected) {
                return 'titleForLTEMarketplaceByor';
            }
            return 'titleForLTEMarketplace';
        }
        case "4g/plans": {
            if(isSingleAddress && isByor) return 'labelForFWALoggedInOneRouter';
            if (isByorSelected) {
                return 'titleForLTEMarketplaceByor';
            }
            return 'titleForLTEMarketplace';
        }
        case "gridwall/all": return 'labelForNSEFlow'
        case "gridwall/smartphones": return 'labelForNSEFlow'
        case "gridwall/tablets": return 'labelForNSEFlow'
        case "gridwall/tablets": return 'labelForNSEFlow'
        case "gridwall/laptops": return 'labelForNSEFlow'
        case "shop/select-account": return "labelForNSEFlowWithAccount"
        case "marketplace/gridwall": return "labelForMarketplaceFlow"        
        default: return (pathForSteps && typeof pathForSteps == "object" && Object.keys(pathForSteps).length) ? pathForSteps[getSwitchPath] : ''
    }
}

export const getCompletedSteps = ({ steps = [], pathForDevices, completedPagedForHPB, reinitiateFlow = false, activeIndex }) => {
    if (activeIndex === 0) return []
    let completedIndex = new Set()
    let isDummyPageEnding = false
    completedPagedForHPB?.map(data => {
        let finalData = data
        if (String(finalData).charAt(0) === '/') finalData = String(finalData).slice(1)
        if (pathForDevices && pathForDevices[finalData] && steps.includes(pathForDevices[finalData])) {
            completedIndex.add(steps.findIndex(item => item === pathForDevices[finalData]))
            isDummyPageEnding = false
        }else if(pathForDevices && pathForDevices[finalData] && steps && steps.length && typeof steps === "object" ){
        const isStepisThere = steps.find(data=>String(data).toLowerCase().includes(String(pathForDevices[finalData]).toLowerCase()))
        if(isStepisThere){
            completedIndex.add(steps.findIndex(item => item === isStepisThere))
        }
        } else {
            isDummyPageEnding = true
        }
    })
    if (!reinitiateFlow) {
        let maxIndex = Math.max.apply(this, [...completedIndex]);
        completedIndex = new Set()
        for (let i = 0; i <= maxIndex; i++) {
            completedIndex.add(i)
        }
    }

    const completedSteps = Array.from(completedIndex)
    if (completedSteps?.length !== activeIndex || activeIndex === 1 || isDummyPageEnding)
        completedSteps.pop()
    return completedSteps
}

export const checkForPlanFirstPaths = (storedPath, getSwitchPath, isPlanFirst) => {
    let paths = [...storedPath]
    let setPath = new Set(storedPath)
    if (isPlanFirst && getSwitchPath.includes("shop/plans")) {
        if (storedPath.indexOf("shop/features") > 0) {
            paths = [...paths.splice(0, paths.indexOf("shop/features")), getSwitchPath, ...paths.splice(paths.indexOf("shop/features"))]
            setPath = new Set(paths)
        }
    } else if (getSwitchPath.includes("smartphones") && !getSwitchPath.includes("devices/smartphones")) {
        paths = [...paths.splice(0, paths.indexOf("devices/smartphones") + 1), getSwitchPath]
        setPath = new Set(paths)
    } else {
        setPath.add(getSwitchPath)
    }

    return setPath
}

export const getPathName = ({ storedPath = [], navigatePath }) => {
    let setPath = new Set(storedPath)
    const getSwitchPath = getSteps(navigatePath)
    setPath.add(getSwitchPath)
    return Array.from(setPath)
}

export const getActiveStep = ({ steps = [], pathForDevices, currentActiveIndex = 0, reinitiateFlow = false, completedPagedForHPB, navigatePath }) => {

    let activeStep = currentActiveIndex
    const getSwitchPath = getSteps(navigatePath)
    if (pathForDevices && pathForDevices[getSwitchPath] && steps.includes(pathForDevices[getSwitchPath])) {
        activeStep = steps.findIndex(item => item === pathForDevices[getSwitchPath])
    }else if(pathForDevices && pathForDevices[getSwitchPath]&& steps && steps.length && typeof steps === "object" ){
        const isStepisThere = steps.find(data=>String(data).toLowerCase().includes(String(pathForDevices[getSwitchPath]).toLowerCase()))
        if(isStepisThere){
            activeStep = steps.findIndex(item => item === isStepisThere)
        }
    } else if (steps?.includes("Review plan") && getSwitchPath?.includes("smartphones")) {
        activeStep = 1
    } else if (reinitiateFlow) {
        let step = 0
        let dummyStep = false
        Object.values(completedPagedForHPB || {})?.forEach(page => {
            if (pathForDevices[page]) {
                step++
                dummyStep = false
            } else {
                dummyStep = true
            }
        });
        dummyStep && step > 0 && step--
        activeStep = step === 1 ? 0 : step
    }
    return activeStep
}

export const getBYODText = ({ index = 0, text = "", pages }) => {
    if (pages?.filter(step => step.includes("byod")).length > 0) {
        if (text === "Select device") return "Add device details"
    }

    // const initialPath = String(window.location.pathname).split('/')
    // const initialPathLength = initialPath.length
    // const getSwitchPath = initialPath[initialPathLength-1] 
    //if(text==="Select device" && getSwitchPath.includes('byod')) return "Add device details"
    return text
}

export const isFlowChanged = ({ globalData, steps = [], plansFirstCategories = [], pageData }) => {
    let flowChanged = false
    if (globalData.selectedIndexForFWAHPB === 1 && steps && steps.length === 4) flowChanged = true
    else if (globalData.selectedIndexForFWAHPB === 0 && steps && steps.length > 4) flowChanged = true
    else if ((globalData.currentFlowForHPB === 'planFirstSteps' || globalData.currentFlowForHPB === 'planFirstStepsWithProtection')
        && (globalData.flow === 'plans-first' && !plansFirstCategories.includes(globalData.category)
            && pageData?.isPlansFirstCategory)) flowChanged = true
    else if ((globalData.currentFlowForHPB !== 'planFirstSteps' && globalData.currentFlowForHPB !== 'planFirstStepsWithProtection')
        && (globalData.flow === 'plans-first' && plansFirstCategories.includes(globalData.category)
            && pageData?.isPlansFirstCategory && !globalData.isPlanFirstFlowCompleted)) flowChanged = true
    else {
        const getSwitchPath = getSteps()
        // if(getSwitchPath === "devices/all") flowChanged = true
        // else if((globalData.currentFlowForHPB === 'deviceFirstSteps' || globalData.currentFlowForHPB === 'deviceFirstStepsWithProtection') 
        if ((globalData.currentFlowForHPB === 'deviceFirstSteps' || globalData.currentFlowForHPB === 'deviceFirstStepsWithProtection')
            && getSwitchPath?.includes("desk-conference-phones")) flowChanged = true
    }

    return flowChanged
}

export const checkIfPDPFlowFresh = ({ deviceName = undefined, accessoryName = undefined, completedSteps = [], activeIndex = 0 }) => {
    const getSwitchPath = getSteps()
    if (getSwitchPath === "shop/pdp" || getSwitchPath === "marketplace/pdp") return true

    // if(!!completedSteps && completedSteps.length && (((deviceName && String(completedSteps[completedSteps.length - 1]).includes(deviceName)) || (accessoryName && String(completedSteps[completedSteps.length - 1]).includes(accessoryName))))
    // ){
    // return true
    // }
    return false
}

export const getFlowForShoppingCart = ({ flow = '', packages, showProtectionPage }) => {
    if (!!packages && Object.keys(packages).length) {
        let getFlow = []
        Object.values(packages).map(data => {
            getFlow.push(data.packageType)
        })
        const isOnlyRegular = getFlow.filter(data => data === 'REGULAR')
        if (isOnlyRegular.length === getFlow.length) {
            if (flow === "planFirstSteps" || flow === "planFirstStepsWithProtection" || flow === "oneTalkSteps") {
                return flow
            } else {
                if (showProtectionPage) return 'deviceFirstSteps'
                else return 'deviceFirstStepsWithProtection'
            }
        }
    }
    return flow
}

export const getReInitiatedFlow = ({ completedPagedForHPB = [], flow, getIndexFromAEM, currentActiveStep = 0, planFirstFlow = false,
    pathForDevices }) => {

    let completedSteps = [...completedPagedForHPB]
    let activeStep = currentActiveStep

    const getSwitchPath = getSteps()
    // if (completedPagedForHPB.includes(getSwitchPath)) return { completedSteps, activeStep }

    if (flow && getIndexFromAEM && Object.keys(getIndexFromAEM).length && typeof getIndexFromAEM == "object") {
        Object.entries(getIndexFromAEM).map(([key, value]) => {
            if ((String(flow).includes(key) || String(key).includes(flow)) && value !== currentActiveStep) {
                let step = 0
                let dummyPages = 0
                let stepCounter = true
                let prevPage = ""
                let addLastPageToList = false
                Object.values(completedPagedForHPB || {})?.forEach((page, index) => {
                    if (pathForDevices[page] && prevPage != "devices/smartphones") stepCounter && step++
                    else {
                        if (prevPage === "devices/smartphones" && page?.includes("smartphones") && getSwitchPath.includes("smartphones")
                            && completedPagedForHPB.length - 1 > index) {
                            stepCounter = false
                            if (page !== getSwitchPath && completedSteps[completedSteps.length - 1].includes("smartphones")) addLastPageToList = true
                            else dummyPages++
                            // dummyPages--
                        }
                        stepCounter && dummyPages++
                        // if(getSwitchPath.includes("smartphones") && prevPage.includes("smartphones")) stepCounter = false;
                    }
                    prevPage = page
                    if (page === getSwitchPath) stepCounter = false;
                });

                let progressValue = step // === 0 ? 1 : step
                activeStep = addLastPageToList ? step - 1 : step
                let addToVisitedPages = ""
                if (addLastPageToList) addToVisitedPages = completedSteps[completedSteps.length - 1]

                completedSteps = completedSteps.splice(planFirstFlow ? 1 : 0, progressValue + dummyPages)
                if (addLastPageToList && addToVisitedPages) completedSteps.push(addToVisitedPages)

            }
        })
    }
    return { completedSteps, activeStep }
}

export const checkForGWSteps = (completedPages) => {
    if (completedPages && completedPages.length > 1) {
        const getSwitchPath = getSteps()
        let pages = [...completedPages]
        if (getSwitchPath !== completedPages[completedPages?.length - 1]) {
            if (getSwitchPath.includes("smartphones") && completedPages[completedPages?.length - 1].includes("smartphones")
                && completedPages[completedPages?.length - 2].includes("devices/smartphones")) {
                return pages.splice(0, completedPages.length - 1)
            }
        }
    }
    return completedPages
}

export const reinitiateFlowIfSessionIsEmpty = ({ globalData }) => {
    if (globalData) {
        if ((globalData.sessionCartData === null || !globalData.sessionCartData || !Object.keys(globalData.sessionCartData).length)) return true
        else if (!!globalData?.sessionCartData && Object.keys(globalData?.sessionCartData).length > 0 && !!globalData?.sessionCartData?.apiResponse && !!globalData?.sessionCartData?.apiResponse?.prospectFlowData &&
            !!globalData?.sessionCartData?.apiResponse?.prospectFlowData && !!globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart && !!globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart?.packages &&
            !Object.keys(globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart?.packages).length) return true
    }

    return false
}

export const handleCheckMarkClick = ({ currentStep = '', navigate = () => { }, pathForDevices = undefined, fromProspect = false }) => {
    if (fromProspect && currentStep === "Review cart") {
        const event = new Event("addToCartCompletedInMarketPalce");
        window.dispatchEvent(event);
    }
    else if (currentStep && pathForDevices && pathForDevices[currentStep]) navigate(pathForDevices[currentStep])
}